const SCORE_LEVELS = [
  { score: 5, label: 'EXTREME BULL', color: '#22c55e' },
  { score: 4, label: 'VERY BULLISH', color: '#22c55e' },
  { score: 3, label: 'BULLISH', color: '#4ade80' },
  { score: 2, label: 'LEAN BULL', color: '#86efac' },
  { score: 1, label: 'SLIGHT BULL', color: '#bbf7d0' },
  { score: 0, label: 'NEUTRAL', color: '#94a3b8' },
  { score: -1, label: 'SLIGHT BEAR', color: '#fca5a5' },
  { score: -2, label: 'LEAN BEAR', color: '#f87171' },
  { score: -3, label: 'BEARISH', color: '#ef4444' },
  { score: -4, label: 'VERY BEARISH', color: '#dc2626' },
  { score: -5, label: 'EXTREME BEAR', color: '#dc2626' },
];

export default function ScoreKey() {
  return (
    <div
      className="rounded-[10px] border overflow-hidden"
      style={{ backgroundColor: '#161b22', borderColor: '#30363d' }}
    >
      <div
        className="px-4 py-3 border-b"
        style={{ borderColor: '#30363d' }}
      >
        <span
          className="font-mono text-xs tracking-[0.12em] uppercase"
          style={{ color: '#8b949e' }}
        >
          Score Key
        </span>
      </div>
      <div className="px-4 py-3 space-y-1">
        {SCORE_LEVELS.map((level) => (
          <div key={level.score} className="flex items-center justify-between">
            <span
              className="font-mono text-[11px]"
              style={{ color: level.color }}
            >
              {level.score > 0 ? `+${level.score}` : level.score}
            </span>
            <span
              className="font-mono text-[10px] tracking-[0.06em]"
              style={{ color: level.color, opacity: 0.7 }}
            >
              {level.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
